import styled from '@emotion/styled';

import MaterialTextField from '../MaterialTextField/MaterialTextField';

export default styled(MaterialTextField)`
  ${(props) => {
    const { disableDropdown, disableCountryCode, forceLtr } = props;
    const noflip = forceLtr ? '/* @noflip */' : '';
    let inputPaddingLeft = '5rem';
    if (disableDropdown) {
      inputPaddingLeft = disableCountryCode ? '0' : '1.4rem';
    }

    let inputWidthOffset = '6rem';
    if (disableDropdown) {
      inputWidthOffset = disableCountryCode ? '0px' : '2.4rem';
    }

    return `

            & .MuiInputBase-input {
                ${noflip}
                text-align: left;
            }

            &&& .react-tel-input {
                font-family: inherit;
                font-size: inherit;
                z-index: auto;
                position: relative;
                ${forceLtr ? '/* @noflip */ direction: ltr;' : ''}

                .flag-dropdown {
                    ${disableDropdown && 'display: none;'}

                    background: none;
                    border: none;

                    .country-list {
                        margin-top: 0;
                        ${noflip}
                        margin-left: 1.4rem;
                    }
                }

                .selected-flag {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: transparent;

                    .flag {
                        position: static;
                        margin: 0;

                        &:focus {
                            background: none;
                        }
                    }
                }

                input {
                    ${noflip}
                    padding-left: ${inputPaddingLeft};
                    // bellow calculation is required because Material input does not account for additional padding
                    width: calc(100% - ${inputWidthOffset});
                    ${noflip}
                    padding-right: 10px;

                    &:not(.MuiOutlinedInput-input) {
                      ${noflip}
                      padding-right: 0;
                    }
                }
            }
        `;
  }}
`;
